<template>
  <i
    v-on="$listeners"
    :class="[
      `${prefix}ic-wrapper-primary-${getPrimaryColor}`,
      `${prefix}ic-wrapper-secondary-${getSecondaryColor}`,
      { ...getIconSize }
    ]"
  >
    <component :is="getIcon"></component>
  </i>
</template>

<script>
import IconMixins from './mixins';

export default {
  name: 'MpxIcon',
  mixins: [IconMixins],
  props: {
    prefix: {
      type: String,
      default: 'mpx-',
    },
    variant: {
      type: String,
      default: 'chevron-up',
    },
    isDuotone: {
      type: Boolean,
      default: false,
    },
    primaryColor: {
      type: String,
      default: null,
    },
    secondaryColor: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: null,
    },
  },
  computed: {
    getIcon() {
      return `MpxIcon${this.getCapitalizeIconName}`;
    },
    getIconSize() {
      const output = {};
      output[`${this.prefix}ic--small`] = this.size === 'small';
      return output;
    },
    getPrimaryColor() {
      if (this.primaryColor) {
        return this.primaryColor;
      }

      if (this.isDuotone) {
        return 'primary-400';
      }

      return 'slate';
    },
    getSecondaryColor() {
      if (this.secondaryColor) {
        return this.secondaryColor;
      }

      if (this.isDuotone) {
        return 'icon-base';
      }

      return 'transparent';
    },
    getCapitalizeIconName() {
      const iconName = this.variant.split('-');
      let capitalizeIconName = '';
      iconName.forEach(name => {
        capitalizeIconName += name[0].toUpperCase() + name.slice(1);
      });
      return capitalizeIconName;
    },
  },
};
</script>
